import { useInkind } from '@gik/api/inkinds/inkind';
import { useInkindCan } from '@gik/core/store/permissions';
import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { inkindPageTourSelectors } from '@gik/inkind-page/components/InkindPageTour/InkindPageTour';
import { Button } from '@gik/ui/Button';
import { SidebarSection } from '@gik/ui/gik/SidebarSection';
import React from 'react';
import { useIsMounted } from '@gik/core/hooks/hooks/useIsMounted';

type WishlistSidebarSectionProps = {
  inkindRouteId: string;
} & UIComponent;

export function WishlistSidebarSection({
  inkindRouteId,
  className,
  children,
  ...otherProps
}: React.PropsWithChildren<WishlistSidebarSectionProps>) {
  const bem = useBemCN('wishlist-sidebar-section');

  const { data: inkindPage } = useInkind(inkindRouteId);
  const giftingUrl = inkindPage?.inkindSituations?.length > 0 && inkindPage.inkindSituations[0]?.giftingUrl;
  const canEdit = useInkindCan('manage', inkindRouteId, inkindPage?.groupId);
  const mounted = useIsMounted();

  return (
    <SidebarSection
      {...otherProps}
      {...bem(null, null, className)}
      title="Wishlist"
      append={
        mounted() &&
        canEdit && (
          <Button
            id={inkindPageTourSelectors.addItemsWishlist}
            disabled={!giftingUrl}
            {...bem('button')}
            variant={'secondary'}
            href={giftingUrl || '#'}
          >
            Add Items
          </Button>
        )
      }
    >
      {children}
    </SidebarSection>
  );
}
